import type { I18nFn } from '#/i18n/types/I18nFn';

export function EXPECTED_TIMES_ONCE(i18n: I18nFn) {
  return [
    {
      /* TRANSLATORS: Form option for volop time commitment */
      name: i18n('A few minutes'),
      id: 'FEW_MINUTES',
    },
    {
      /* TRANSLATORS: Form option for volop time commitment */
      name: i18n('A few hours'),
      id: 'FEW_HOURS',
    },
    {
      /* TRANSLATORS: Form option for volop time commitment */
      name: i18n('A few days'),
      id: 'FEW_DAYS',
    },
    {
      /* TRANSLATORS: Form option for volop time commitment */
      name: i18n('A few weeks'),
      id: 'FEW_WEEKS',
    },
    {
      /* TRANSLATORS: Form option for volop time commitment */
      name: i18n('Flexible'),
      id: 'FLEXIBLE',
    },
  ];
}
